import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './rental-badge.css'

function TileRentalBadge({
  hide, isGrid
}) {
  return (
    <div
      className={classnames(styles.rentalBadgeWrapper, {
        [styles.hide]: hide,
        [styles.isGrid]: isGrid
      })}
    >
      <div className={styles.rentalBadge}>
        $
      </div>
    </div>
  )
}

TileRentalBadge.propTypes = {
  hide: PropTypes.bool,
  isGrid: PropTypes.bool
}

TileRentalBadge.defaultProps = {
  hide: false,
  isGrid: false
}

export default TileRentalBadge
